<template>
    <fragment>
        <navbar></navbar>
        <div class="row">
            <div class="col l8 offset-l2 m10 offset-m1 s10 offset-s1">
                <slot></slot>
            </div>
        </div>
    </fragment>
</template>
<script>
export default {
    beforeCreate() {
        this.$store.dispatch("checkActivation");
    },
}
</script>
<style lang="scss">
   
</style>